import { EReputationMatchResult } from "src/core/types/entity";
import { WatchlistIconType, isWatchlistIconType } from "src/core/types/watchlist";

/**
 * @description Récupère les types de watchlist depuis les icônes de résumé de la personne et le détail.
 *
 * Si la personne est RCA, on la tag aussi comme PEP.
 */
export const getEntityWatchlistTypes = (result: EReputationMatchResult): Set<WatchlistIconType> => {
  const watchlistIcons = new Set<WatchlistIconType>();

  // On récupère les types de watchlist depuis les icônes de résumé de la personne.
  const riskIcons: string[] = result?.riskIcons?.filter((item) => isWatchlistIconType(item)) ?? [];
  riskIcons.forEach((item) => watchlistIcons.add(item as WatchlistIconType));

  // On vérifie aussi dans le détail s'il n'est pas RCA et si c'est le cas,
  // on le tag aussi comme PEP.
  if (result.detail?.watchlist.some((item) => item.type.toLowerCase().includes("rca"))) {
    watchlistIcons.add(WatchlistIconType.PEP);
  }

  return watchlistIcons;
};
